import AMName from "./AMName";

export default class MetadataParser {

    static setDefaultMetadatas(allDefaultMetadatas: DefaultMetadatas, ams: AssesmentMethod[] ) {
        //valPlanTemplate -> mis am sees, igale ühele default
        ams.forEach(am => {
            let am_name = AMName.getAMNameFromAMCodeName(am.code_name)
            let defaultMetadatas = allDefaultMetadatas[am_name];
            am.metadatas = defaultMetadatas || [];
        })
        return ams
    }

    static getMetadatasFromJsons(template : Template){
        let template_ams = template.ams           //     ams : AssesmentMethod[];
        for (let am of template_ams) {
            am.metadatas = []
        }
        let all_am_metadatas= template.am_metadatas // am_metadatas : AmMetadata[] : am_code_name: string;metadata : string;
        for (let am_metadata of all_am_metadatas) {
            try{
                let metadata = JSON.parse(am_metadata.metadata) // Metadata :type
                for (let am of template_ams) {
                    if (am_metadata.am_code_name===am.code_name){
                        if(am.metadatas == undefined){
                            am.metadatas = [metadata]
                        } else {
                            am.metadatas.push(metadata)
                        }
                    }
                }
            } catch (e) {

            }
        }
        return template
    }

    static setMetadataJsons(template : Template){
        template.am_metadatas = []
        for (let am of template.ams) {
            for(let metadata of am.metadatas || []) {
                template.am_metadatas.push(
                    {
                        am_code_name: am.code_name,
                        metadata: JSON.stringify(metadata)
                    }
                )
            }
        }
        // this.setMetadataJsonsFromAms(template, template.ams);
        return template;
    }

    static setAmMetadata(template: Template, am : AssesmentMethod) {
        am.metadatas = []
        let all_am_metadatas= template.am_metadatas // am_metadatas : AmMetadata[] : am_code_name: string;metadata : string;
        for (let am_metadata of all_am_metadatas) {
            try{
                let metadata = JSON.parse(am_metadata.metadata) // Metadata :type
                if (am_metadata.am_code_name === am.code_name){
                    if(am.metadatas == undefined){
                        am.metadatas = [metadata]
                    } else {
                        am.metadatas.push(metadata)
                    }
                }
            } catch (e) {

            }
        }
    }

    static setMetadataJsonsFromAms(template: Template, ams: AssesmentMethod[]) {
        template.am_metadatas = []
        for (let am of ams) {
            for(let metadata of am.metadatas || []) {
                template.am_metadatas.push(
                    {
                        am_code_name: am.code_name,
                        metadata: JSON.stringify(metadata)
                    }
                )
            }
        }
        console.log("setMetadataJsonsFromAms ",template)
        return template;
    }
}

export interface Metadata {
    type: string;
    [key: string]: any;
}

export interface DefaultMetadatas {
    [amName : string] : Metadata[]
}

export interface AssesmentMethod {
    code_name:string;
    metadatas?:Metadata[];
    [key: string]: any;
}

export interface AmMetadata {
    am_code_name: string;
    metadata : string;
}

export interface Template {
    am_metadatas : AmMetadata[];
    ams : AssesmentMethod[];
    [key: string]: any;
}


